import { RegEx } from "../constants";

export const isValidSip = (sip: string) => {
	return RegEx.Sip.test(sip);
};

export const isValidPhoneNumber = (number: string) => {
	const cleanedNumber = number.replace(/[\u0000-\u001F\u007F-\u009F\u200B\u200C\u200D\uFEFF]+$/g, "").trim();

	return RegEx.PhoneNumber.test(cleanedNumber);
};

export const isValidToneKeyNumber = (number: string) => {
	return RegEx.DTMF.test(number);
};

export const isValidTimeSpan = (input: string) => {
	return RegEx.TimeSpan.test(input);
};

export const isValidEmail = (input: string): boolean => {
	if (!input) {
		return false;
	}

	try {
		const cleanedEmail = input.normalize('NFKC')
			.replace(/\p{Cf}|\p{Cc}|\p{Zs}/gu, '')
			.trim();

		return RegEx.Email.test(cleanedEmail);
	} catch {
		return RegEx.Email.test(input);
	}
};

export const isValidRouteCallDestination = (input: string): boolean => {
	return RegEx.RouteCallDestination.test(input);
}

export const isValidGuid = (input: string): boolean => {
	return RegEx.Guid.test(input);
}

const getMobileNumberFromSip = (sip: string) => {
	if (!sip) {
		return "";
	}

	return sip.replace("tel:", "").replace("sip:", "").split("@")[0];
};

const getMobileNumberFromString = (phone: string) => {
	if (!phone) {
		return "";
	}

	return phone.replace(/(?![0-9]|[+*#])./g, "");
};

const isMobileNumber = (sip: string) => {
	return /^(\d|\+|#)+$/.test(getMobileNumberFromSip(sip)!);
};

const hasNumbers = (value: string) => {
	return /\d/.test(value);
};

export const formatSipOrPhoneNumber = (phone: string) => {
	if (phone.includes("@") && phone.split("@")[1]!.includes(".")) {
		if (isMobileNumber(phone)) {
			return getMobileNumberFromSip(phone);
		}

		return phone.replace("tel:", "");
	}

	if (phone.length > 0) {
		if (hasNumbers(phone)) {
			return getMobileNumberFromString(phone);
		}

		return phone;
	}

	return "";
};
